import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const token = useSelector((state) => state.admin.token);
  return token ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
